/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : AircraftDetailsWrapper.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : AircraftDetails Wrapper component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Jan 10,2022
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAircraftDetailsMasterData } from "stores/AircraftDetailsStore";
import { AircraftDetails } from "components/AircraftDetails";

export const AircraftDetailsWrapper: FC<Record<string, unknown>> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAircraftDetailsMasterData());

    // eslint-disable-next-line
  }, []);
  return <AircraftDetails />;
};
